import { firebase, db } from '../firebase';

export default class ScoreCalculatorStage {
    calculate() {
        return new Promise(function (ok, err) {
            firebase.auth().onAuthStateChanged(user => {
                if (!user) {
                    return err('Missing authenticated user');
                }

                db.collection('answers').doc(user.uid).get().then(doc => {
                    const data = doc.data();

                    if (!data.stage) {
                        return err('Cannot get stage questionnaire data');
                    }

                    const sessions = Object.keys(data.stage);
                    const latestSession = sessions.slice(-1).pop();
                    const answers = data.stage[latestSession];

                    const score = Object.values(answers).reduce((score, answer) => score + (answer.score || 0), 0);
                    ok(score);
                });
            });
        });
    }
}
